import Icon from '@/common/components/Icon';
import { FlexCell } from '../components/refundTable/RefundTable.styles';
import moment from 'moment';
import { REFUND_STATUSES, REFUND_REASONS } from '@/common/constants/refunds';

const TO_DO_STATUS = 'TO_DO';
const NOT_ACCEPTED_STATUS = 'NOT_ACCEPTED';

const formatDate = (date) => (date ? moment(date).format('DD-MM-YYYY') : '-');

const getProcessedDate = (refund, selectedStatus) => {
	if (selectedStatus === NOT_ACCEPTED_STATUS) {
		return refund.no_refund_date || refund.updated_at;
	}

	return refund.refund_date || refund.updated_at;
};

const getDocumentCell = (refund, handleDownloadPdf, loadingFiles) => {
	if (!refund.files?.length) {
		return '-';
	}

	return (
		<FlexCell>
			{refund.files.map((file) =>
				loadingFiles.includes(file) ? (
					<Icon key={file} onClick={() => false} name='spinner' spin />
				) : (
					<Icon
						key={file}
						name='file-pdf'
						onClick={() => handleDownloadPdf(file)}
					/>
				),
			)}
		</FlexCell>
	);
};

export const getRows = (
	refunds,
	selectedStatus,
	setSelectedRefund,
	handleDownloadPdf,
	loadingFiles,
) =>
	refunds.map((refund, index) => {
		const isToDoStatus = selectedStatus === TO_DO_STATUS;
		const isNotAcceptedStatus = selectedStatus === NOT_ACCEPTED_STATUS;
		const documentCell = getDocumentCell(
			refund,
			handleDownloadPdf,
			loadingFiles,
		);

		return (
			<tr
				style={{
					fontWeight: 'bold',
				}}
				key={refund._id}
			>
				<td>{index + 1}</td>
				<td>{refund.market.name}</td>
				<td>
					{refund.consultant.name} {refund.consultant.surname}
				</td>
				<td>{formatDate(refund.created_at)}</td>
				{isToDoStatus ? (
					<>
						<td>
							{
								REFUND_REASONS.find((reason) => reason.value === refund.reason)
									?.label
							}
						</td>
						<td>{refund.amount}</td>
						<td>{refund.market.currency}</td>
						<td>{documentCell}</td>
						<td>
							<FlexCell>
								<Icon onClick={() => setSelectedRefund(refund)} name='edit' />
							</FlexCell>
						</td>
					</>
				) : (
					<>
						<td>{formatDate(getProcessedDate(refund, selectedStatus))}</td>
						<td>{refund.amount}</td>
						<td>{refund.market.currency}</td>
						<td>{documentCell}</td>
						<td>
							{
								REFUND_STATUSES.find((status) => status.value === refund.status)
									?.label
							}
						</td>
						{isNotAcceptedStatus && <td>{refund.comment || '-'}</td>}
					</>
				)}
			</tr>
		);
	});
